__turbopack_context__.v({
  "image": "progressive-image-module__nSLr3q__image",
  "progressiveImage": "progressive-image-module__nSLr3q__progressiveImage",
  "show": "progressive-image-module__nSLr3q__show",
});
